import React from "react";

function Header(props) {
  return (
    <div className="banner-container">
      <h1>
        {" "}
        <a href="/"> Marvel Quizz</a>
      </h1>
    </div>
  );
}

export default Header;
